import Marquee from "react-fast-marquee";

const ITEMS = [
  "Messagerie instantanée",
  "AG en Visioconférence à 360°",
  "Vote électronique sécurisé",
  "Suivi d'incidents",
  "Procès-verbal digitalisé",
  "Feuille de présence",
  "Convocations en LRE",
  "Webapp multi-plateforme",
  "Support 24h/24",
];

const Dot = () => <span className="mx-8 inline-block h-1.5 w-1.5 rounded-full bg-white/70" />;

export const MarqueeBand = () => (
  <div
    className="overflow-hidden border-y border-white/20 bg-[linear-gradient(110deg,#00C4CC_0%,#2BC97E_100%)] py-6"
    data-testid="marquee-band"
  >
    <Marquee speed={35} gradient gradientColor="#00C4CC" gradientWidth={140} direction="right">
      {ITEMS.map((item) => (
        <span
          key={item}
          className="flex items-center whitespace-nowrap text-sm font-bold uppercase tracking-[0.25em] text-white"
        >
          <Dot />
          {item}
        </span>
      ))}
    </Marquee>
  </div>
);
